import { Component } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Observable } from 'rxjs';
import { StorageKeys } from '@enums/storage-keys.enum';
import { StorageService } from '@providers/storage/storage.service';
import { AVAILABLELANGUAGES_ES, DEFAULTLANGUAGE } from '@data/i18n.data';
import { LoaderManagmentService } from '@providers/loader-managment/loader-managment.service';
import { SharedService } from '@providers/shared/shared.service';
import { TranslationService } from '@providers/translation-new/translation.service';
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  messages: string;
  testingVar: boolean;
  theme$: Observable<boolean>;
  title = 'passer-electron-autoUpdater';

  constructor(
    private loading: LoaderManagmentService,
    private sharedService: SharedService,
    private storage: Storage,
    private storageService: StorageService,
    private translation: TranslationService
  ) {
    this.initProsess();
  }

  async initProsess(): Promise<void> {
    await this.themeLoader();
    await this.setLanguage();
  }

  async themeLoader() {
    await this.storage.create();
    const themeMode = await this.storageService.getData(StorageKeys.DARK_MODE);
    this.sharedService.changeTheme(!!themeMode);
    await this.storageService.setData(StorageKeys.DARK_MODE, !!themeMode);
  }

  async setLanguage(): Promise<void> {
    let userLang;
    try {
      const response = await this.storageService.getData(StorageKeys.LANG);
      userLang = response ?? DEFAULTLANGUAGE;
    } catch (e) {
      userLang = DEFAULTLANGUAGE;
    }

    const lang = AVAILABLELANGUAGES_ES[userLang === DEFAULTLANGUAGE ? 1 : 0];
    this.translation.setCurrentLang(lang);
  }

  isLoading(): boolean {
    return this.loading.isLoading();
  }
}
